import { createSelector } from 'reselect';
import Immutable from 'immutable';

const CATEGORY_PLACEHOLDER_IMAGE = 'https://d27vybgvtr1dba.cloudfront.net/category-ph.jpg';

export const selectLibrarySummary = createSelector(
  categories => categories,
  categories =>
    categories
      ? categories.get('data').map(category => {
          const sectionRecords = category.get('sections').reduce((videos, section) => {
            return videos.concat(section.get('libraryRecords'));
          }, new Immutable.List());

          const imageSrc =
            category.getIn(['image', 'location']) ||
            category.getIn(['course', 'image', 'location']) ||
            CATEGORY_PLACEHOLDER_IMAGE;

          return new Immutable.Map({
            name: category.get('name'),
            id: category.get('id'),
            isCourse: category.get('is_course'),
            imageSrc: imageSrc || null,
            recordCount: sectionRecords.size,
          });
        })
      : new Immutable.List()
);

export const selectFavoritesAsCategory = createSelector(
  favorites => favorites,
  favorites => {
    if (!favorites.get('data')) {
      return new Immutable.Map();
    }

    const librarySection = new Immutable.Map({
      name: 'Library Videos',
      id: 'Library Videos',
      libraryRecords: favorites.get('data').reduce((accumulator, favorite) => {
        if (favorite.getIn(['libraryRecord', 'id'])) {
          return accumulator.push(favorite.get('libraryRecord').set('favorited', true));
        }

        return accumulator;
      }, new Immutable.List()),
    });

    const episodeSection = new Immutable.Map({
      name: 'Episode Videos',
      id: 'Episode Videos',
      libraryRecords: favorites.get('data').reduce((accumulator, favorite) => {
        if (favorite.getIn(['tvEpisode', 'id'])) {
          return accumulator.push(favorite.get('tvEpisode').set('favorited', true));
        }

        return accumulator;
      }, new Immutable.List()),
    });

    return Immutable.fromJS({
      id: 'favorites',
      name: 'My Favorites',
      sections: Immutable.List([librarySection, episodeSection]),
    });
  }
);

export const selectFavoritesSummary = createSelector(
  favorites => favorites,
  favorites => {
    if (!favorites.get('data')) {
      return new Immutable.Map();
    }
    const mostRecentVideo = favorites
      .get('data')
      .sort((a, b) => a.get('id') < b.get('id'))
      .first();

    let imageSrc = CATEGORY_PLACEHOLDER_IMAGE;

    if (mostRecentVideo) {
      imageSrc =
        (mostRecentVideo.get('library_video_id')
          ? mostRecentVideo.getIn(['libraryRecord', 'image', 'location'])
          : mostRecentVideo.getIn(['tvEpisode', 'image', 'location'])) || imageSrc;
    }

    return new Immutable.Map({
      name: 'My Favorites',
      id: 'favorites',
      imageSrc: imageSrc,
      recordCount: favorites.get('data').size,
    });
  }
);

export const selectActiveCategory = createSelector(
  [(categories, categoryId) => categories, (categories, categoryId) => categoryId],
  (categories, categoryId) => {
    if (categories) {
      return categories.get('data').find(category => category.get('id') === parseInt(categoryId, 10));
    } else {
      return new Immutable.map();
    }
  }
);

export const selectActiveLibraryRecord = createSelector(
  [(category, videoId) => category, (category, videoId) => videoId],
  (category, videoId) => {
    return category.get('sections').reduce((result, section) => {
      const video = section.get('libraryRecords').find(record => record.get('id') === parseInt(videoId, 10));
      if (video) {
        return video;
      }

      return result;
    }, null);
  }
);



// WEBPACK FOOTER //
// ./src/subscription/library/redux/selectors.js